export class VendorFieldsDTOForIR{
  public business_name?:string
  public vendor_code?:string
}
export class IRSearchDTO{
  public ir_no?:string
  public ir_date?:string
  public net_value?:string
  public tax_value?:string
  public gross_value?:string
  public invoice_no?:string
  public invoice_date?:string
  public status?:string
  public partially_amount?:string
  public balance_amount?:string
}
